module.exports = new __parcel__URL__("style.7d1d36f1.css").toString();